import { useEffect } from 'react';

import { ThemeProvider } from '@change/ds-core-ui/next';

import { Translate } from '@change-corgi/core/react/i18n';
import { createModalHook } from '@change-corgi/design-system-legacy/modals';

import { useIsFullSunriseEnabled } from '../../hooks/isFullSunriseEnabled';
import { preloadShare, ShareContainer } from '../share';
import { ShareContainer as ShareContainerSunrise } from '../shareSunrise';

import { MobileModalContextDecorator } from './shared/MobileModalContextDecorator';
import type { MobileModalContext } from './shared/types';

const PRELOAD_SHARE_DELAY = 5000;

export const useMobileShareModal = createModalHook<MobileModalContext>({
	name: 'MobileShareModal',
	variant: 'fullPage',
	closeOnBreakpoints: [false, true],
	title: function MobileShareModalTitle() {
		return <Translate value="fe.components.petition_share.action" />;
	},
	body: function MobileShareModalBody() {
		const {
			data: { isSunriseShareModuleExperimentEnabled },
		} = useIsFullSunriseEnabled();
		return isSunriseShareModuleExperimentEnabled ? (
			<ThemeProvider>
				<ShareContainerSunrise forMobileView />
			</ThemeProvider>
		) : (
			<ShareContainer forMobileView />
		);
	},
	decorator: ({ children, options }) => (
		<MobileModalContextDecorator {...options}>{children}</MobileModalContextDecorator>
	),
});

export function usePreloadMobileShareModal(): void {
	useEffect(() => {
		const timeout = window.setTimeout(() => {
			void preloadShare();
		}, PRELOAD_SHARE_DELAY);

		return () => window.clearTimeout(timeout);
	});
}
